import { useQuery } from "@tanstack/react-query";
import { message } from "antd";
import { interceptor } from "../utils/interceptor";
import { QUERY_OPTIONS } from "../lib/query-constants";

export const useGenericQuery = ({
    queryKey,
    endpoint,
    queryParams = {},
    onSuccess,
    onError,
    options = {},
    enabled = true
}) => {
    const axiosInstance = interceptor();
    return useQuery({
        queryKey,
        queryFn: async () => {
            const { data } = await axiosInstance.get(endpoint, { params: queryParams });
            return data.data;
        },
        onSuccess: (data) => {
            if (onSuccess) onSuccess(data);
            else console.log(`Query ${queryKey} success:`, data);
        },
        onError: (error) => {
            if (onError) onError(error);
            else {
                const msg = error?.response?.data?.message || error.message || "Error occurred";
                message.error(msg);
                console.error(`Query ${queryKey} error:`, error);
            }
        },
        enabled,
        ...options,
        ...QUERY_OPTIONS,
    });
};
